import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card shadow-sm mb-4" }
const _hoisted_2 = { class: "card-content p-2" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "row visit-card" }
const _hoisted_7 = { class: "col-10" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "border-end time-slot float-start pt-3 me-2" }
const _hoisted_10 = { class: "text-secondary fw-bold" }
const _hoisted_11 = { class: "text-primary fw-bold" }
const _hoisted_12 = { class: "mobile-visit-card" }
const _hoisted_13 = { class: "fw-bold text-secondary" }
const _hoisted_14 = { class: "overflow-hidden" }
const _hoisted_15 = {
  key: 1,
  class: "text-center pt-3"
}
const _hoisted_16 = {
  key: 1,
  class: "loading-card-area"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lazy_pagination = _resolveComponent("lazy-pagination")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "card-header text-white bg-secondary fw-bold" }, "Completed Scorecards", -1)),
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.visit_loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (Object.keys(_ctx.props.completed_scorecards).length)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.completed_scorecards, (visit_observer) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: visit_observer.id,
                      class: "col-12",
                      onClick: ($event: any) => (_ctx.router.push({name:'visit',params:{visit_id:visit_observer.visit_id}}))
                    }, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("img", {
                            src: visit_observer.visit.scenario.patient_image.location,
                            class: "rounded-circle float-start me-2",
                            width: "75"
                          }, null, 8, _hoisted_8),
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.moment(visit_observer.visit.utc_time || visit_observer.visit.local_time).format('MM/DD/YY')), 1),
                            _cache[0] || (_cache[0] = _createElementVNode("hr", { class: "my-1" }, null, -1)),
                            _createElementVNode("span", _hoisted_11, [
                              _createTextVNode(_toDisplayString(_ctx.moment(visit_observer.visit.utc_time || visit_observer.visit.local_time).format('h:mm')), 1),
                              _createElementVNode("sup", null, _toDisplayString(_ctx.moment(visit_observer.visit.utc_time || visit_observer.visit.local_time).format('a')), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, _toDisplayString(visit_observer.visit.scenario.patient_name), 1),
                            _createElementVNode("div", _hoisted_14, _toDisplayString(visit_observer.visit.scenario.title), 1)
                          ])
                        ]),
                        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "col-2 d-flex flex-column justify-content-center" }, [
                          _createElementVNode("h3", { class: "text-center" }, [
                            _createElementVNode("i", { class: "fas fa-clipboard-check text-primary" })
                          ])
                        ], -1))
                      ]),
                      _cache[2] || (_cache[2] = _createElementVNode("hr", { class: "w-75" }, null, -1))
                    ], 8, _hoisted_5))
                  }), 128)),
                  (_ctx.props.completed_scorecards_total > 10)
                    ? (_openBlock(), _createBlock(_component_lazy_pagination, {
                        key: 0,
                        items: _ctx.props.completed_scorecards,
                        total: _ctx.props.completed_scorecards_total,
                        page_start: _ctx.page_start,
                        page_end: _ctx.page_end,
                        onNextPage: _ctx.nextPage,
                        onPreviousPage: _ctx.previousPage,
                        label: 'Scorecards'
                      }, null, 8, ["items", "total", "page_start", "page_end", "onNextPage", "onPreviousPage"]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_15, "No Completed Scorecards"))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createVNode(_component_loading, {
              active: _ctx.visit_loading,
              "is-full-page": false
            }, null, 8, ["active"])
          ]))
    ])
  ]))
}